export default __webpack_public_path__ + "static/media/pic03.72913cf1.jpg";